import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'
import { DomainUnfilledRecoveryDTO } from '../types/domainUnfilledRecoveryDTO'

export const DOMAIN_UNFILLED_RECOVERY_FRAGMENT = (
  ability: Ability,
): TypedDocumentNode<DomainUnfilledRecoveryDTO> => gql`
  fragment DomainUnfilledRecoveryFragment on DomainUnfilledRecovery {
    ${permitFields<DomainUnfilledRecoveryDTO>({
      baseAdUnitPath: ability.can('read', 'DomainField-baseAdUnitPath'),
    })}

    cacheAndReusePrebidBids
  }
`
